var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstruct = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 0.675903C31.0385 0.675903 40 9.63745 40 20.6756V21.3243C40 32.3625 31.0385 41.3241 20.0003 41.3241C8.96155 41.3246 0 32.3625 0 21.3243V20.6756C0 9.63745 8.96155 0.675903 19.9997 0.675903Z",
    fill: "#EACDA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2446 17.9348V17.9463H23.5675C23.7502 17.9463 23.8974 17.8026 23.8974 17.6245V12.3217C23.8974 12.1436 23.7502 12 23.5675 12H16.4386C16.2559 12 16.1086 12.1436 16.1086 12.3217V17.6188C16.1086 17.7969 16.2559 17.9405 16.4386 17.9405H19.7615V17.929H20.2446V17.9348ZM16.7685 17.2971V12.6492H23.2376V17.2971H16.7685Z",
    fill: "#FFF8E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7947 28.6782V23.3812C14.7947 23.2031 14.6474 23.0594 14.4648 23.0594H7.32993C7.14729 23.0594 7 23.2031 7 23.3812V28.6782C7 28.8563 7.14729 29 7.32993 29H14.4589C14.6415 29 14.7888 28.8563 14.7888 28.6782H14.7947ZM14.1289 28.3565H7.66576V23.7087H14.1348V28.3565H14.1289Z",
    fill: "#FFF8E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4325 23.0594C16.2498 23.0594 16.1025 23.2031 16.1025 23.3812V28.6782C16.1025 28.8563 16.2498 29 16.4325 29H23.5614C23.7441 29 23.8913 28.8563 23.8913 28.6782V23.3812C23.8913 23.2031 23.7441 23.0594 23.5614 23.0594H16.4325ZM23.2315 28.3565H16.7683V23.7087H23.2315V28.3565Z",
    fill: "#FFF8E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5353 23.0594C25.3526 23.0594 25.2053 23.2031 25.2053 23.3812V28.6782C25.2053 28.8563 25.3526 29 25.5353 29H32.6642C32.8468 29 32.9941 28.8563 32.9941 28.6782V23.3812C32.9941 23.2031 32.8468 23.0594 32.6642 23.0594H25.5353ZM32.3343 28.3565H25.8711V23.7087H32.3343V28.3565Z",
    fill: "#FFF8E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0889 22.6056H11.572V20.8419H19.7555V22.6056H20.2445V20.8419H28.4222V22.6056H28.9112V20.3708H20.2445V17.9406V17.9348H19.7555V17.9406V20.3708H11.0889V22.6056Z",
    fill: "#FFF8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstruct, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instruct.af68a973.svg";
export { ForwardRef as ReactComponent };